import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PrintApiModel } from '@app/api/api-models/reports/PrintApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export abstract class BaseReportService<TReportFiltersApiModel, TReportRequestApiModel, TReportApiModel> {
  public abstract readonly apiUrl: string;

  public constructor(protected readonly http: HttpClientService) {}

  public getFilters(): Observable<TReportFiltersApiModel> {
    return this.http.get<TReportFiltersApiModel>(`${this.apiUrl}/filters`);
  }

  public getReport(request: TReportRequestApiModel): Observable<TReportApiModel> {
    return this.http.post<TReportApiModel>(`${this.apiUrl}/report`, request);
  }

  public getPdf(model: PrintApiModel<TReportRequestApiModel>): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/pdf`, model, { responseType: 'blob' });
  }

  public getXlsx(model: TReportRequestApiModel): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/xlsx`, model, { responseType: 'blob' });
  }

  public getXlsxAll(model: PrintApiModel<TReportRequestApiModel>): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/xlsx-all`, model, { responseType: 'blob' });
  }
}
